import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { Ng2TelInputModule } from 'ng2-tel-input'
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker'
import { BaseAtylModule } from '../../../base/base.module'
import { MaterialModule } from '../../../material.module'
import { PipesModule } from '../../../pipes/pipes.module'
import { PartialsModule } from '../../../views/partials/partials.module'
import { TableAtylDisplayModule } from '../form-table-atyl-display/table-atyl-display.module'
import { SubFormAtylComponent } from '../sub-form-atyl/sub-form-atyl.component'
import { AtylInputObserveComponent } from './atyl-input-observe/atyl-input-observe.component'
import { FormAtylInputComponent } from './form-atyl-input.component'
import * as components from './form-input-type'
import { HistoriqueListingComponent } from './historique-listing/historique-listing.component'
import { ListingInformationComponent } from './historique-listing/listing-information/listing-information.component'
import { NgxSummernoteModule } from 'ngx-summernote'

//import { TiersAdresseComponent } from '../../../views/partials/layout/tiers-adresse/tiers-adresse.component'
//import * as ta from '../../../views/partials/layout/tiers-adresse/tiers-adresse.component'

import { NumericDirective } from "./form-input-type/form-input-number/numeric.dictective"

const componentList = [
	components.FormInputAdresseComponent,
	components.FormInputAgrementComponent,
	components.FormInputCheckBoxComponent,
	components.FormInputDateComponent,
	components.FormInputDaterangeComponent,
	components.FormInputDividerComponent,
	components.FormInputDropDownComponent,
	components.FormInputEmailComponent,
	components.FormInputLabelComponent,
	components.FormInputNumberComponent,
	components.FormInputRadioComponent,
	components.FormInputSelectionlistComponent,
	components.FormInputTableComponent,
	components.FormInputTelComponent,
	components.FormInputTextComponent,
	components.FormInputTextareaComponent,
	components.FormInputListComponent,
	components.FormInputAdresseSharedComponent,
	components.SearchAdresseComponent,
	components.FormInputSignatureComponent,
	components.FormInputPlaceComponent
]
@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		ReactiveFormsModule,
		FormsModule,
		MaterialModule,
		TableAtylDisplayModule,
		NgxMaterialTimepickerModule.setOpts('fr-FR','french'),
		Ng2TelInputModule,
		BaseAtylModule,
		PipesModule,
		PartialsModule,
		NgxSummernoteModule,
		

	],
	declarations: [
		FormAtylInputComponent,
		SubFormAtylComponent,
		AtylInputObserveComponent,
		HistoriqueListingComponent,
		NumericDirective,
		ListingInformationComponent,
		...componentList
	],
	exports: [
		FormAtylInputComponent,
		AtylInputObserveComponent,
		HistoriqueListingComponent,
		ListingInformationComponent,	
		//ta.TiersAdresseComponent,	
		...componentList
	],
	entryComponents: [
		components.SearchAdresseComponent,
		//TiersAdresseComponent,
	]
})
export class FormAtylInputModule { }
